import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import QuestionActionListComponent from './QuestionActionListComponent';
import { Card, IconButton, Pagination, TextField } from '@totalsoft/rocket-ui';
import Details from '@mui/icons-material/PlaylistAdd';
import Search from '@mui/icons-material/Search';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const QuestionActionListCard = ({
  questionActions,
  questionActionTypes,
  onSave,
  onDelete,
  validation,
  isReadOnly,
  onRowsPerPageChange,
  onPageChange,
  onRefresh,
  pagination,
  totalCount,
  fullTextFilter,
  onChangeFilterValue,
  onAddNewQuestionAction,
  rowsPerPageOptions,
  onPropertyChanged,
  onExpandedChanged,
  getIndexInFilteredList
}) => {
  const { t } = useTranslation();
  const onTextFilterChanged = detailValue => {
    onChangeFilterValue(detailValue);
  };

  const resetFilters = _ => onTextFilterChanged('');

  return (
    <Card
      icon={Details}
      iconColor='primary'
      title={t('Questionnaire.QuestionActions')}
      subheader={
        <TextField
          id={'documentVerificationList_filters_fullText'}
          name='fullTextFilter'
          value={fullTextFilter}
          onChange={event => onTextFilterChanged(event)}
          placeholder={t('Cauta dupa tipul actiunii')}
          startAdornment={<Search />}
          endAdornment={
            <IconButton
              color='transparent'
              type='cancel'
              fontSize='medium'
              tooltip={t('Tooltips.ResetFilters')}
              onClick={resetFilters}
              id={'documentVerificationList_filters_resetBtn'}
            />
          }
        />
      }
      actions={
        <IconButton
          color='transparent'
          type='add'
          fontSize='medium'
          tooltip={t('Tooltips.Add')}
          onClick={onAddNewQuestionAction}
          disabled={isReadOnly}
        />
      }
      footer={
        <Pagination
          loading={false}
          count={totalCount}
          pageSize={pagination.pageSize}
          page={pagination.page}
          rowsPerPageOptions={rowsPerPageOptions}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={onPageChange}
          onRefresh={onRefresh}
        />
      }
    >
      <CardNoResultsWrapper content={questionActions}>
        <QuestionActionListComponent
          questionActions={questionActions}
          questionActionTypes={questionActionTypes}
          onSave={onSave}
          onDelete={onDelete}
          validation={validation}
          isReadOnly={isReadOnly}
          onPropertyChanged={onPropertyChanged}
          onExpandedChanged={onExpandedChanged}
          getIndexInFilteredList={getIndexInFilteredList}
        />
      </CardNoResultsWrapper>
    </Card>
  );
};

QuestionActionListCard.propTypes = {
  questionActions: PropTypes.array.isRequired,
  questionActionTypes: PropTypes.array,
  onAddNewQuestionAction: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object,
  isReadOnly: PropTypes.bool,
  onPropertyChanged: PropTypes.func.isRequired,
  onExpandedChanged: PropTypes.func.isRequired,
  getIndexInFilteredList: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  pagination: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  fullTextFilter: PropTypes.string.isRequired,
  onChangeFilterValue: PropTypes.func.isRequired,
  rowsPerPageOptions: PropTypes.array.isRequired
};

export default QuestionActionListCard;
